import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkCreateTeam, IClientDetailsActions } from '../../types';

const onCreateTeam: IThunkCreateTeam = thunk(
  async ({ setClientDetails }: Actions<IClientDetailsActions>, payload) => {
    const { requestInfo, requestPayload } = payload;
    const client = await api.clientTeams.createTeam(requestInfo, requestPayload).then(r => r.data);
    setClientDetails({ actTeams: client.actTeams });

    return client.actTeams;
  },
);

export default onCreateTeam;
